import { __assign } from "tslib";
import React from 'react';
import { getItemTarget } from '../utils/utils';
import InternalIcon from '../../icon/internal';
import ItemIcon from './item-icon';
var ExternalIcon = function (_a) {
    var item = _a.item;
    var disabled = item.disabled, externalIconAriaLabel = item.externalIconAriaLabel;
    var icon = React.createElement(InternalIcon, { variant: disabled ? 'disabled' : 'normal', name: "external" });
    return externalIconAriaLabel ? (React.createElement("span", { role: "img", "aria-label": externalIconAriaLabel }, icon)) : (icon);
};
var LinkItem = function (_a) {
    var item = _a.item, disabled = _a.disabled, optionProps = _a.optionProps;
    var hasIcon = !!(item.iconName || item.iconSvg || item.iconUrl);
    return (React.createElement("a", __assign({}, optionProps, { href: !disabled ? item.href : undefined, target: getItemTarget(item), rel: item.external ? 'noopener noreferrer' : undefined }),
        hasIcon && React.createElement(ItemIcon, { name: item.iconName, url: item.iconUrl, svg: item.iconSvg, alt: item.iconAlt }),
        React.createElement("span", null,
            item.text,
            " ",
            item.external && React.createElement(ExternalIcon, { item: item }))));
};
export default LinkItem;
//# sourceMappingURL=link-item.js.map